import React, { useState } from "react";
import {Modal, Typography, Button,} from "antd";
import * as dispatcherNotesActions from "../../../../redux/actions/dispactherNote.actions";
import { validationErrors } from "../../../../utils/Helpers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const { Text } = Typography;

const NotesDeleteModal = (props) => {
  const [MBtnLoading, setMBtnLoading] = useState(false);

  const onSubmit = async () => {
    try {
      setMBtnLoading(true);
      await props.dispatcherNotesActions.dispactherNoteDeleteAction(props.postdata.postid);
    } catch (e) { validationErrors(e) } finally {
      setMBtnLoading(false);
      props.handleCancel();
      props.refreshData();
    }
  };
  return (
    <Modal
      title="Note Delete"
      visible={props.handlevisible}
      onCancel={props.handleCancel}
      footer={[
        <Button loading={MBtnLoading} onClick={props.handleCancel}>Cancel</Button>,
        <Button loading={MBtnLoading} onClick={onSubmit}>Submit</Button>,
      ]}
      style={{top: 20,}}
    >
      <p>Are you sure to delete</p>
      <p>ID: {props.postdata.displayid}</p>
      <p>Note: {props.postdata.value}</p>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatcherNotesActions: bindActionCreators(dispatcherNotesActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(NotesDeleteModal);
// export default NotesDeleteModal;
